// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 48,
        /* Optional */
        loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    // 'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    // 'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="product-item" data-handle="{{handle}}">' +
        '<a href="{{itemUrl}}">' +
        '<span class="product-item__badge{{badgeClass}}" style="background-color: {{badgeBg}};">' +
        '<span>{{badgeText}}</span>' +
        '</span>' +
        '<div class="ir">' +
        '<img src="{{itemThumbUrlRetina}}" />' +
        '<div class="product-open-quick-view-container" style="display: none">' +
        '<div aria-label class="product-open-quick-view">' +
        '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="search-plus" class="svg-inline--fa fa-search-plus fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M312 196v24c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h68v-68c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm196.5 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-3.5-8.5v-13.2c-36.5 31.5-84 50.6-136 50.6C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 52-19.1 99.5-50.6 136h13.2c3.2 0 6.2 1.3 8.5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 0 17zM368 208c0-88.4-71.6-160-160-160S48 119.6 48 208s71.6 160 160 160 160-71.6 160-160z"></path></svg>' +
        'Quickview' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="title">' +
        '<ul class="swatches {{swatchListClass}}">' +
        '{{swatchHtml}}' +
        '</ul>' +
        '<span class="item-1">{{itemTitle}}</span>' +

        '<span class="price product-item__price">' +
        '<span class="product-item__price-original">{{itemPrice}}</span>' +
        '</span>' +
        '</div>' +
        '</a>' +
        '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span>{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<h3 class="collection-sort__title">Sort By</h3><select name="Sort By" id="sortSelect" class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    var imageSize = '630x';
    var imageSizeRetina = '1260x';
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data[ 'variants' ][ 0 ];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[ 0 ] !== 'undefined') firstVariant = paramVariant[ 0 ];
    } else {
        for (var i = 0; i < data[ 'variants' ].length; i++) {
            if (data[ 'variants' ][ i ].available) {
                firstVariant = data[ 'variants' ][ i ];
                break;
            }
        }
    }
    var badgeText = '';
    var badgeClass = '';
    var badgeKey;
    var colorsHtml = '';
    var handle = data.handle;
    var imgUrl = '//cdn.shopify.com/s/files/1/1679/4075/files/color-';
    var swatchListClass = 'hide';
    data.tags.forEach(function (tag) {
        if (tag.indexOf('Badge: ') !== -1) {
            badgeText = tag.split('Badge: ')[ 1 ];
            badgeClass = badgeText.toLowerCase();
            badgeClass = badgeClass.replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g, "");
            badgeClass = badgeClass.replace(/\s+/g, "-");
            badgeKey = 'badge_bg_' + badgeClass.replace(/-/g, "_");
            badgeClass = ' ' + badgeClass;
        }
    });
    data.options_with_values.forEach(function (opt) {
        if (opt.name === 'color') {

            var colors = opt.values;

            if (colors.length < 2) return;

            swatchListClass = '';

            colors.forEach(function (color) {
                var colorName = color.title.toLowerCase(),
                    colorHandle = colorName.replace(/\s+/g, '-'),
                    colorImage = color.image;

                colorsHtml += '<li data-value="' + colorName + '" data-img="" class="swatch-element color ' + colorHandle + ' available">';
                colorsHtml += '<img class="pi__swatch swatch-image" src="' + imgUrl + colorHandle + '_small.png" />';
                colorsHtml += '</li>';
            });
        }
    });

    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[ 0 ][ 'src' ], imageSize) : bcSfFilterConfig.general.no_image_url;
    var itemThumbUrlRetina = images.length > 0 ? this.optimizeImage(images[ 0 ][ 'src' ], imageSizeRetina) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemThumbUrlRetina}}/g, itemThumbUrlRetina);

    // check sizes length
    // Check Options
    var isSize = data.options_with_values[ 0 ].name;
    var sizeLength = data.options_with_values[ 0 ].values.length;
    var itemSizesHtml = isSize === 'size' && sizeLength > 1 ? sizeLength + ' Sizes / ' : '';
    itemHtml = itemHtml.replace(/{{itemSizes}}/g, itemSizesHtml);


    // Add Price
    var itemPriceHtml = '';
    if (data.title != '') {
        itemPriceHtml += '<span class="product-item__price-filtered">';
        if (onSale) {
            itemPriceHtml += '<s class="product-item__price-compare">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
        }

        // if (priceVaries) {
        //     console.log(bcSfFilterConfig.label.from_price);
        //     itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/Price/g, this.formatMoney(data.price_min));
        // } else {
        // console.log(priceVaries, bcSfFilterConfig);
        itemPriceHtml += this.formatMoney(data.price_min);
        // }
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // add badge class and color
    var badgeBg = badgeKey ? badgeJson[ badgeKey ] : 'transparent';
    itemHtml = itemHtml.replace(/{{badgeClass}}/g, badgeClass);
    itemHtml = itemHtml.replace(/{{badgeText}}/g, badgeText);
    itemHtml = itemHtml.replace(/{{badgeBg}}/g, badgeBg);

    // add color swatches
    itemHtml = itemHtml.replace(/{{swatchHtml}}/g, colorsHtml);
    itemHtml = itemHtml.replace(/{{swatchListClass}}/g, swatchListClass)

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = data.vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    itemHtml = itemHtml.replace(/{{handle}}/g, handle);

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
    for (var k in data) {
        // Featured image
        if (data[ 'images_info' ] > 0) {
            data[ k ][ 'featured_image' ] = data[ 'images_info' ][ 0 ];
        } else {
            data[ k ][ 'featured_image' ] = { width: '', height: '', aspect_ratio: 0 }
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[ k ][ 'options_with_values' ]) {
            optionsArr.push(data[ k ][ 'options_with_values' ][ i ][ 'name' ]);
        }
        data[ k ][ 'options' ] = optionsArr;


        // Customize variants
        for (var i in data[ k ][ 'variants' ]) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[ k ][ 'variants' ][ i ];
            // Add Options
            var variantOptions = variant[ 'merged_options' ];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[ j ].split(':');
                    data[ k ][ 'variants' ][ i ][ 'option' + (parseInt(j) + 1) ] = temp[ 1 ];
                    data[ k ][ 'variants' ][ i ][ 'option_' + temp[ 0 ] ] = temp[ 1 ];
                    variantOptionArr.push(temp[ 1 ]);
                }
                data[ k ][ 'variants' ][ i ][ 'options' ] = variantOptionArr;

            }
            data[ k ][ 'variants' ][ i ][ 'compare_at_price' ] = parseFloat(data[ k ][ 'variants' ][ i ][ 'compare_at_price' ]) * 100;
            data[ k ][ 'variants' ][ i ][ 'price' ] = parseFloat(data[ k ][ 'variants' ][ i ][ 'price' ]) * 100;
        }

        // Add Description
        data[ k ][ 'description' ] = data[ k ][ 'body_html' ];
    }

    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[ iPage ] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[ iPage ] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[ iPage ]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[ iPage ]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[ k ] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            jQ(this.selector.topSorting).change(() => {
                setTimeout(() => {
                    window.dispatchEvent(new Event('filters.filterUpdated'));
                }, 500);
            });
            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {

    // product tout
    if (window.toutProductJson) {
        var toutProductJsonData = window.toutProductJson.html;
        var toutProductJsonPosition = window.toutProductJson.position;
        jQ('#bc-sf-filter-products > article.pi:nth-child(' + toutProductJsonPosition + ')').after(toutProductJsonData);
    }

    // quote banner tout
    if (window.toutQuoteBannerJson) {
        var toutQuoteBannerJsonData = window.toutQuoteBannerJson.html;
        var toutQuoteBannerJsonPosition = window.toutQuoteBannerJson.position;
        jQ('#bc-sf-filter-products > article.pi:nth-child(' + toutQuoteBannerJsonPosition + ')').after(toutQuoteBannerJsonData);
    }

    // blockquote banner
    if (window.toutBlockquoteJson) {
        var toutBlockquoteJsonData = window.toutBlockquoteJson.html;
        var toutBlockquoteJsonPosition = window.toutBlockquoteJson.position;
        jQ('#bc-sf-filter-products > article.pi:nth-child(' + toutBlockquoteJsonPosition + ')').after(toutBlockquoteJsonData);
    }

};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    this.buildRobotsMetaTag();

    // selected filters count
    var selectedLength = jQ('#bc-sf-filter-tree').find('.bc-sf-filter-option-item.selected').length;
    var btn;
    if (selectedLength === 0) {
        btn = jQ('#filtersCount').text('');
        jQ('.filters__clear-all').addClass('hide');
    } else {
        btn = jQ('#filtersCount').text('(' + selectedLength + ')');
        jQ('.filters__clear-all').removeClass('hide');
    }
};

/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function (data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find(metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function () { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[ 0 ], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };


BCSfFilter.prototype.getFilterData = function (eventType, errorCount) { function BCSend(eventType, errorCount) { var self = bcsffilter; var errorCount = typeof errorCount !== "undefined" ? errorCount : 0; self.showLoading(); if (typeof self.buildPlaceholderProductList == "function") { self.buildPlaceholderProductList(eventType) } self.beforeGetFilterData(eventType); self.prepareRequestParams(eventType); self.queryParams[ "callback" ] = "BCSfFilterCallback"; self.queryParams[ "event_type" ] = eventType; var url = self.isSearchPage() ? self.getApiUrl("search") : self.getApiUrl("filter"); var script = document.createElement("script"); script.type = "text/javascript"; var timestamp = (new Date).getTime(); script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams); script.id = "bc-sf-filter-script"; script.async = true; var resendAPITimer, resendAPIDuration; resendAPIDuration = 2e3; script.addEventListener("error", function (e) { if (typeof document.getElementById(script.id).remove == "function") { document.getElementById(script.id).remove() } else { document.getElementById(script.id).outerHTML = "" } if (errorCount < 3) { errorCount++; if (resendAPITimer) { clearTimeout(resendAPITimer) } resendAPITimer = setTimeout(self.getFilterData("resend", errorCount), resendAPIDuration) } else { self.buildDefaultElements(eventType) } }); document.getElementsByTagName("head")[ 0 ].appendChild(script); script.onload = function () { if (typeof document.getElementById(script.id).remove == "function") { document.getElementById(script.id).remove() } else { document.getElementById(script.id).outerHTML = "" } } } this.requestFilter(BCSend, eventType, errorCount) }; BCSfFilter.prototype.requestFilter = function (sendFunc, eventType, errorCount) { sendFunc(eventType, errorCount) };


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) { var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic") ? fOData.keepValuesStatic : false; if (fOType == "review_ratings" && this.getSettingValue("general.ratingSelectionStyle") == "text") { var title = this.getReviewRatingsLabel(fOItemValue.from) } else { var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType) } if (keepValuesStatic === true) var productNumber = null; else var productNumber = fOItemValue.hasOwnProperty("doc_count") ? fOItemValue.doc_count : 0; html = html.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(iLabel, productNumber, fOData)); html = html.replace(/{{itemLink}}/g, this.buildFilterOptionLink(fOId, iValue, fOType, fODisplayType, fOSelectType, keepValuesStatic)); html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue)); html = html.replace(/{{itemTitle}}/g, title); html = html.replace(/{{itemFunc}}/g, "onInteractWithFilterOptionValue(event, this, '" + fOType + "', '" + fODisplayType + "', '" + fOSelectType + "', '" + keepValuesStatic + "')"); html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType) ? html.replace(/{{itemSelected}}/g, "selected") : html.replace(/{{itemSelected}}/g, ""); var htmlElement = jQ(html); htmlElement.children().attr({ "data-id": fOId, "data-value": encodeURIParamValue(iValue), "data-parent-label": fOLabel, "data-title": title, "data-count": productNumber }); if (fOType != "collection") { htmlElement.children().attr("rel", "nofollow") } if (fOType == "collection") htmlElement.children().attr("data-collection-scope", fOItemValue.key); return jQ(htmlElement)[ 0 ].outerHTML };
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter = function () { return this.isBadUrl() ? void (window.location.href = window.location.pathname) : (this.updateApiParams(!1), void this.getFilterData("init")) }, BCSfFilter.prototype.isBadUrl = function () { try { var t = decodeURIComponent(window.location.search).split("&"), e = !1; if (t.length > 0) for (var i = 0; i < t.length; i++) { var n = t[ i ], a = (n.match(/</g) || []).length, r = (n.match(/>/g) || []).length, o = (n.match(/alert\(/g) || []).length, h = (n.match(/execCommand/g) || []).length; if (a > 0 && r > 0 || a > 1 || r > 1 || o || h) { e = !0; break } } return e } catch (l) { return !0 } };
/* End patch boost-010 run 2 */
